/**
 * Reset state back to initial state.
 *
 * @param {object} state - Current state.
 * @param {object} initialState - Initial state.
 */

export const reset = (
    state: { [x: string]: any },
    initialState: { [x: string]: any }
) => {
    Object.keys(initialState).forEach((key) => {
        state[key] = initialState[key];
    });
};
